// A bin configured for monitoring that has no device installed yet. Deliberately distinct
// from an inactive bin, which is not monitored at all — the two states render differently.
export function isMonitoredWithNoDevice(binProperties) {
  const { monitoringType, hasDevice } = binProperties || {};
  return monitoringType === 'monitored' && !hasDevice;
}
